module.exports = __webpack_public_path__ + "static/media/dollar-not.f92da437.svg";